import React, { useMemo, useState } from "react";
import _ from "lodash";
import { makeRequest } from "../../../utils/request";
import Dropdown from "../../common/Dropdown";
import { getContentDetailsOnClick } from '../../../utils/utility'

const CardHeader = ({ post, showPmbokModal, canProceed, booksList = [] }) => {
  const [loadingPmbok, setLoadingPmbok] = useState(false);
  const bookList = booksList || []
  const postAttributionSources = post.attributionSources || []
  const showAttributionLink = (postAttributionSources[0] !== null) || false

  const attributionSourcesList = (bookList, postAttributionSources) => {
    if (!bookList.length) { return [] }
    const attributionLinkList = _.forEach(postAttributionSources, postSource => {
      _.forEach(bookList, book => {
        if (postSource.book === book.key) {
          postSource.label = book.title
        }
      })
    });
    const validAttributionLinkList = _.filter(attributionLinkList, function (f) { return f.link !== null; }) || []
    return validAttributionLinkList || []
  }
  const attributionSourcesListItems = attributionSourcesList(bookList, postAttributionSources) || []
  const attributionLink = (
    <span>
      {loadingPmbok && <i className="fas fa-spinner fa-spin" />}
      <Dropdown
        id="login_widget"
        items={attributionSourcesListItems}
        buttonLabel={
          <span className="text-lg text-black no-underline font-medium">
            <span className="text-sm px-3 mt-2 sm:mt-0 text-blue-700 cursor-pointer text-blue-700">
              View Source
              <i className="fas fa-chevron-down align-middle ml-1"></i>
            </span>
          </span>
        }
        onClickItem={item => showModal(item, attributionSourcesListItems)}

        itemsStyles="border border-gray-400 agrandir text-xs"
      />
    </span>
  );

  const showModal = async (item, attributionSources) => {
    const fragmentsVS = item && item.link && item.link.trim().split(":")[1] || "";
    const bookname = item.book;
    if (fragmentsVS && canProceed()) {
      setLoadingPmbok(true);
      const data = await makeRequest(
        "get",
        `/api/pmbok/${bookname}/fragments/${fragmentsVS}`
      );
      setLoadingPmbok(false);
      if (data) {
        data.attributionSources = attributionSources || []
        showPmbokModal(data);
      }
    }
    getContentDetailsOnClick(post, item.label, 'card-header')
    //await mutate("/api/playlist/getplaylistwithlikes", newUserLikes);

  };


  const renderIcon = () => {
    const postMediaType = post.mediaType.length === 1 ? post.mediaType[0]?.id ?
      post.mediaType[0].id : post.mediaType[0] : ''
    if (postMediaType === 'MTPmbok6') {
      return <img alt="pmbok6 icon" src="/images/pmbok6-icon.svg" width="45" />;
    }
    if(postMediaType === "MTEVM"){
      return <img alt="mtevm icon" src="/images/pmbok-mtevm-icon.svg" width="45" />;
    }
    if(postMediaType === "MTPMO"){
      return <img alt="mtevm icon" src="/images/pmopg-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTPmbok7') {
      return <img alt="pmbok7 icon" src="/images/pmbok7-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTAPG') {
      return <img alt="apg icon" src="/images/apg-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTGBA') {
      return <img alt="gba icon" src="/images/gba-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTWBS') {
      return <img alt="wbs icon" src="/images/wbs-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTSRM') {
      return <img alt="srm icon" src="/images/srm-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTSPE') {
      return <img alt="srm icon" src="/images/mtse-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTPGP') {
      return <img alt="pgp icon" src="/images/pgp-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTBAG') {
      return <img alt="mtbag icon" src="/images/mtbag-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTSPM') {
      return <img alt="mtspm icon" src="/images/mtspm-icon.svg" width="45" />;
    }
    if (postMediaType === 'MTRMP') {
      return <img alt="MTRMP icon" src="/images/risk-icon.svg" width="45" />;
    }
    return <img src="/images/standards-plus-icon.svg" width="45" />;
  };


  const postSource = (postSource) => {
    if (postSource === 'Work Breakdown Structures') {
      return 'Practice Standard for WBS'
    }
    return postSource
  }

  return (
    <div>
      <div
        id={`#${post.contentKey}`}
        className="flex flex-wrap justify-center sm:flex-no-wrap sm:justify-between items-center px-5 py-2 w-full border-b border-gray-500"
        adoberegion='card-header'>
        <div className="flex items-center">
          {renderIcon()}
          <div className="text-xl font-normal text-black pl-3 header-font">
            {postSource(post.source)}
          </div>
        </div>
        <div
          className="flex items-start justify-end sm:items-center ml-auto flex-1 header-font"
        >
          {showAttributionLink && (attributionSourcesListItems.length > 0) && attributionLink}
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
